import { render } from "./Navbar1.vue?vue&type=template&id=6156bc8a&scoped=true"
import script from "./Navbar1.vue?vue&type=script&lang=js"
export * from "./Navbar1.vue?vue&type=script&lang=js"

import "./Navbar1.vue?vue&type=style&index=0&id=6156bc8a&scoped=true&lang=css"
import "./Navbar1.vue?vue&type=style&index=1&id=6156bc8a&lang=css"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6156bc8a"]])

export default __exports__